/**
 *
 * PersonQuote
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fallbackImage } from 'utils/stringUtils';

const styles = theme => ({
  descriptionContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 35,
    paddingBottom: 30,
    borderRadius: 3,
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: '#fff',
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.primary.contrastText,
  },
  author: {
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 500,
    color: theme.palette.primary.contrastText,
  },
  description: {
    marginBottom: 17,
  },
  title: {
    fontSize: 12,
    color: theme.palette.text.disabled,
    textAlign: 'center',
  },
  avatar: {
    width: 66,
    height: 66,
  },
  avatarWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 24,
  },
});

function PersonQuote(props) {
  const { classes, quote, author, title, image } = props;
  return (
    <Grid item xs={12} className={classes.descriptionContainer}>
      <Grid container justifyContent="center">
        {image && image !== fallbackImage && (
          <Grid item xs={12} className={classes.avatarWrapper}>
            <Avatar className={classes.avatar} src={image} alt={author} />
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography
            className={ClassNames(classes.label, classes.description)}
          >{`"${quote}"`}</Typography>
        </Grid>
        {author && (
          <Grid item xs={12}>
            <Typography className={classes.author}>{author}</Typography>
          </Grid>
        )}
        {title && (
          <Grid item xs={12}>
            <Typography className={classes.title}>{title}</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

PersonQuote.propTypes = {
  classes: PropTypes.object,
  quote: PropTypes.string,
  author: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
};

export default withStyles(styles)(PersonQuote);
